<ng-container *ngIf="visible">
  <div class="modal-backdrop" (click)="close()"></div>
  <div class="modal-container">
    <div class="modal-content">
      <b>{{ title }}</b>
      <p class="mt-2">{{ content }}</p>
      <div class="d-flex gap-10">
        <button class="btn btn-primary" (click)="confirm()">{{ 'modal.confirm' | translate }}</button>
        <button class="btn btn-secondary" (click)="close()">{{ 'modal.close' | translate }}</button>
      </div>
    </div>
  </div>
</ng-container>
